
let autocompleteMixin = {
	data() {
		return {
			phrase: ""
		}
	},
	methods: {
		search(input) {
			const url = `/api/search/searchResult?condition=${encodeURI(input)}`;

			return new Promise(resolve => {
				if (input.length < 3 || this.phrase === input) {
					return resolve([]);
				}

                this.phrase = input;
				fetch(url)
					.then(response => response.json())
					.then(data => {
						resolve(data);
					});
			});
		},
		getResultValue(result) {
			return result.title;
		},
		// Open the selected item in
		// a new window
		handleSubmit(result) {
			if (result.link === "#")
				return;

			location.href = result.link;
		}
	}
}

export default autocompleteMixin;